import React from "react";

interface SpecialityListProps {
  onSpecialitySelect: (speciality: string) => void;
  specialities: any;
}

const SpecialityList: React.FC<SpecialityListProps> = ({
  onSpecialitySelect,
  specialities,
}) => {
  return (
    <ul className="flex flex-col mt-6 w-full text-gray-500">
      {specialities.map((speciality: any, index: number) => (
        <li key={index} className={index > 0 ? "mt-6" : ""}>
          <button
            onClick={() => onSpecialitySelect(speciality)}
            className="text-left w-full hover:text-indigo-600 focus:outline-none focus:text-indigo-600"
          >
            {speciality?.displayName}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default SpecialityList;
